import React , {useState, useEffect} from 'react'
import { useDispatch } from 'react-redux';
import {SetComponentId} from '../../redux/counterSlice'
import YearCalendar from '../../shared/YearlyCalendar';
import { useSelector } from "react-redux";
import API from '../../services/api';
import TableLoader from '../../shared/TableLoader';
import NoDataFound from '../../shared/NoDataFound';

function RevenueAnalysis() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(43))
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [revenueData, setRevenueData] = useState([]);
  const [loader, setLoader] = useState(false);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  

  useEffect(() => {
    const fetchRevenueData = async () => {
      setLoader(true)
      try {
       let res = await API({
        url: `/market/revenue`,
        method: "POST",
        responseType:'json',
        data: {
          year: Math.round(selectedYear /1000)
        }})
        if(res.code === 200){
          setRevenueData(res.data)
        }
       }
       catch (error) {
        console.error("Error fetching revenue data:", error);
      }
      finally{
        setLoader(false)
      }
    };
    fetchRevenueData();
  }, [selectedYear]);

  return (
    <>
    <div className='d-flex flex-wrap justify-between items-center'>
      <h5>Revenue Analysis</h5>
      <YearCalendar startYear={2023} endYear={2100}/>
      </div>
      <table className='table table-bordered'>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Client</th>
          <th>{`${new Date(selectedYear).getFullYear()} Spent`}</th>
          {months.map((month, index) => (
            <th key={index}>{month}</th>
          ))}
          <th>Target Achieved</th>
          <th>Target</th>
        </tr>
        </thead>
        {loader ? <TableLoader colspan={17}/> : revenueData?.length > 0 ? <tbody>
          {revenueData.map((data, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{data.client}</td>
              <td>{data.total_amount}</td>
              {data.month_amount.map((amount, index) => (
                <td key={index}>{amount}</td>
              ))}
              <td>{data.target_achieved}</td>
              <td>{data.target}</td>
            </tr>
          ))}
          </tbody> : <NoDataFound colspan={17}/>}
          </table>
    </>
  )
}
export default RevenueAnalysis